import { moveToFulfilled, moveToRejected, objectWithKeys } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { PrivateTeamsMeetingInviteeAction } from '../../domains/privateTeamsMeetingInvitees/actions.types';

import type { PrivateTeamsMeetingInvitees } from './types';

export type { PrivateTeamsMeetingInviteeAction };

const initialState = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<PrivateTeamsMeetingInvitees, PrivateTeamsMeetingInviteeAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'PRIVATE_TEAMS_MEETING.USER_INVITEES_PENDING': {
      const newPending = objectWithKeys<boolean>(state.pending.byId, action.payload.ids, true);

      return {
        ...state,
        pending: {
          ...state.pending,
          byId: newPending,
        },
      };
    }
    case 'PRIVATE_TEAMS_MEETING.USER_INVITEES_FULFILLED':
      return moveToFulfilled(state, action.payload.invitees);
    case 'PRIVATE_TEAMS_MEETING.USER_INVITEES_REJECTED':
      return moveToRejected(state, action.payload.ids, action.payload.error);
    default:
      return state;
  }
};

export default reducer;
